import { useEffect } from "react";
import Clarity from '@microsoft/clarity'


const Chatbot = () => {

    useEffect(()=> {
        Clarity.init("ra5feguupr")
      },[])

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//code.tidio.co/vkaukf5r3i3gs9quxfetddiesz2cxwrs.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return <></>;
};

export default Chatbot;
